import { replaceEntityById } from '@/lib/entity/replaceEntityById'
import { ApplicationState } from '@/redux/stores/types'

import { IAction } from '../actions/action-helpers'
import { PackagesAndBillingSettingsTypes } from '../actions/actions.types'

type PackagesAndBillingSettingsState = ApplicationState['packagesAndBillingSettings']

export function packagesAndBillingSettingsReducer(
	state: PackagesAndBillingSettingsState = [],
	action: IAction,
): PackagesAndBillingSettingsState {
	switch (action.type) {
		case PackagesAndBillingSettingsTypes.GetPackagesAndBillingSettings.SUCCESS:
			return action.payload
		case PackagesAndBillingSettingsTypes.UpdatePaymentInfo.SUCCESS:
			return replaceEntityById(state, action.payload)
		case PackagesAndBillingSettingsTypes.CreatePackagesAndBillingSettings.SUCCESS:
		case PackagesAndBillingSettingsTypes.UpdatePackagesAndBillingSettings.SUCCESS:
			return action.payload
	}
	return state
}
